import PropTypes from 'prop-types';
import { FaRegCheckCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { SearchModes } from '../../../../../constants';
import hotelSearchInput from '../../../../../helpers/selectors/hotelSearchInput';

const HotelMatchWithSearch = ({ tripId, hotelId }) => {
  const selectedSearchMode = useSelector((store) => store.tripSearch.selectedSearchMode);

  const isHotelTripSearch = selectedSearchMode === SearchModes.HOTEL;
  const { selectedAddress } = useSelector(hotelSearchInput(tripId, isHotelTripSearch));

  return selectedAddress && selectedAddress.hotelId && selectedAddress.hotelId === hotelId ? (
    <div className="text-sm">
      <div className="text-preferenceLabelColor-0">
        <FaRegCheckCircle className="inline -mt-1" />{' '}
        <span>You were interested in this property</span>
      </div>
    </div>
  ) : (
    <></>
  );
};

HotelMatchWithSearch.propTypes = {
  tripId: PropTypes.string,
  hotelId: PropTypes.string.isRequired,
};

HotelMatchWithSearch.defaultProps = {
  tripId: undefined,
};

export default HotelMatchWithSearch;
